import { SubmitHandler, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Stack, Typography } from '@mui/material';

import { i18nNS } from '../../../../i18n';
import { FormValues } from '../PollQuestionForm/types';
import QuestionDescription from './QuestionDescription';
import QuestionOptions from './QuestionOptions';
import { LeftPart, pollQuestionClasses, RightPart } from './styles';
import usePollQuestion from './vm';

export interface PollQuestionProps {
  formMethods: UseFormReturn<FormValues>;
  onSubmit: SubmitHandler<FormValues>;
  onLocalSubmit: SubmitHandler<FormValues>;
  className?: string;
}

const PollQuestion = ({ formMethods, onSubmit, onLocalSubmit, className }: PollQuestionProps) => {
  const { t } = useTranslation([i18nNS.POLL, i18nNS.GLOSSARY]);

  const { handleSubmit } = formMethods;

  const { isPollPublished, isPresenting, pollQuestion } = usePollQuestion();

  if (!pollQuestion) return null;

  return (
    <Stack
      direction="row"
      gap={2}
      component="form"
      noValidate
      onSubmit={handleSubmit(onSubmit)}
      className={className}
    >
      <LeftPart flex={1}>
        <Typography variant="titleBold" visibility={isPollPublished || isPresenting ? 'hidden' : 'visible'}>
          {t('question', { ns: i18nNS.GLOSSARY })}
        </Typography>
        <QuestionDescription
          formMethods={formMethods}
          onSubmit={onSubmit}
          onLocalSubmit={onLocalSubmit}
          isPollPublished={isPollPublished || isPresenting}
          pollQuestion={pollQuestion}
          className={pollQuestionClasses.questionDescription}
        />
      </LeftPart>
      <RightPart flex={1}>
        <Typography variant="titleBold" className={pollQuestionClasses.questionOptionsLabel}>
          {isPollPublished || isPresenting
            ? t('total_responses_colon_N', { ns: i18nNS.POLL, count: pollQuestion.totalAttempts })
            : t('options', { ns: i18nNS.GLOSSARY })}
        </Typography>
        <QuestionOptions
          formMethods={formMethods}
          onSubmit={onSubmit}
          onLocalSubmit={onLocalSubmit}
          isPollPublished={isPollPublished || isPresenting}
          pollQuestion={pollQuestion}
          className={pollQuestionClasses.questionOptions}
        />
      </RightPart>
    </Stack>
  );
};

export default PollQuestion;
